import i18n from '../vuex/i18n/i18n.js';
// 正式地址
export var basicUrl = i18n.locale=='zh'?'https://u.vigame.cn/':'https://c.345ddz.com/u/';//自动
// export var basicUrl = i18n.locale=='zh'?'https://u.vigame.cn/':'http://127.0.0.1:6401/';//自动
// export var basicUrl = 'https://u.vigame.cn/';//国内
// export var basicI18nUrl = 'https://c.345ddz.com/';//海外
// 测试地址
// export var basicUrl = 'http://192.168.1.38:6708';

//客服反馈-常见问题接口
export var getAllQAList = i18n.locale=='zh'?'/feedback/v1/commonQA':'/feedback/v1/commonQA';//自动
// export var getAllQAList = '/feedback/v1/commonQA';//国内
// export var getI18nAllQAList = '/u/feedback/v1/commonQA';//海外
//客服反馈-问题详情接口
export var getQaInfo = i18n.locale=='zh'?'/feedback/v1/qaInfo':'/feedback/v1/qaInfo';//自动
// export var getQaInfo = '/feedback/v1/qaInfo';//国内
// export var getI18nQaInfo = '/u/feedback/v1/qaInfo';//海外
//客服反馈-问题搜索接口
export var getsearch = i18n.locale=='zh'?'/feedback/v1/search':'/feedback/v1/search';//自动
// export var getsearch = '/feedback/v1/search';//国内
// export var getI18nsearch = '/u/feedback/v1/search';//海外


// // 游戏库-请求热门专辑和全部游戏
// export var getAllAppList = '/game/center/getMainData';

// // 排行-获取排行数据
// export var getRankingList = '/game/center/getRankData';

// // 全部专辑-获取全部专辑数据
// export var getAllAlbumList = '/game/center/getAlbumPageData'

// // 专辑详情页面-获取专辑详情数据
// export var getAlbumDetailList = '/game/center/getAlbumDetailData';

// // 分类-获取分类对应游戏
// export var getClassifyAppList = '/game/center/getTypeGameData';

// // 搜索-获取热门分类、热门搜索数据
// export var getHotSearchAndClassifyList = '/game/center/getSearchPageData';

// // 搜索-根据内容查询游戏
// export var getSearchAppList = '/game/center/searchGame';


// WEBPACK FOOTER //
// ./src/utils/api.js